<template>
  <div class="col-md-12">
    <br />
    <form
      name="newDocument"
      class="form-horizontal form-label-left"
      @submit.prevent="handleSubmit()"
    >
      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Type:</label
        >
        <div class="col-md-6 col-sm-6">
          <select name="Type" v-model="encodingData.Type" class="form-control">
            <option value>Select Type</option>
            <option
              v-for="option in types"
              v-bind:value="option.paperType"
              v-bind:key="option.paperType"
            >
              {{ option.paperType }}
            </option>
          </select>
        </div>
      </div>
      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >ReferenceNo :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            v-validate="'max:50'"
            name="ReferenceNo"
            v-model="encodingData.ReferenceNo"
            class="form-control"
            :class="{ 'is-invalid': submitted && errors.has('ReferenceNo') }"
          />
          <div
            v-if="submitted && errors.has('ReferenceNo')"
            class="invalid-feedback"
          >
            {{ errors.first("ReferenceNo") }}
          </div>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >IssuingAgency :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            v-validate="'max:50'"
            name="IssuingAgency"
            v-model="encodingData.IssuingAgency"
            class="form-control"
            :class="{ 'is-invalid': submitted && errors.has('IssuingAgency') }"
          />
          <div
            v-if="submitted && errors.has('IssuingAgency')"
            class="invalid-feedback"
          >
            {{ errors.first("IssuingAgency") }}
          </div>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >IssuanceDate :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            type="date"
            name="IssuanceDate"
            v-model="encodingData.IssuanceDate"
            class="form-control"
          />
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Country:</label
        >
        <div class="col-md-6 col-sm-6">
          <select
            name="Country"
            v-model="encodingData.Country"
            class="form-control"
          >
            <option value>Select Country</option>
            <option
              v-for="option in countries"
              v-bind:value="option.countryName"
              v-bind:key="option.countryName"
            >
              {{ option.countryName }}
            </option>
          </select>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >State:</label
        >
        <div class="col-md-6 col-sm-6">
          <select
            name="SourceId"
            v-model="encodingData.State"
            class="form-control"
          >
            <option value="">Select State</option>
            <option
              v-for="option in provinces"
              v-bind:value="option.province"
              v-bind:key="option.province"
            >
              {{ option.province }}
            </option>
          </select>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >City :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            type="text"
            v-validate="'max:50'"
            name="City"
            v-model="encodingData.City"
            class="form-control"
            :class="{ 'is-invalid': submitted && errors.has('City') }"
          />
          <div v-if="submitted && errors.has('City')" class="invalid-feedback">
            {{ errors.first("City") }}
          </div>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Address :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            v-validate="'max:200'"
            type="text"
            name="City"
            v-model="encodingData.Address"
            class="form-control"
            :class="{ 'is-invalid': submitted && errors.has('City') }"
          />
          <div v-if="submitted && errors.has('City')" class="invalid-feedback">
            {{ errors.first("City") }}
          </div>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Comments :</label
        >
        <div class="col-md-6 col-sm-6">
          <textarea
            name="Comments"
            v-model="encodingData.Comments"
            rows="5"
            cols="5"
            class="form-control"
          />
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Last Name :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            v-validate="'max:200'"
            type="text"
            name="LastName"
            v-model="encodingData.LastName"
            class="form-control"
            :class="{ 'is-invalid': submitted && errors.has('LastName') }"
          />
          <div v-if="submitted && errors.has('LastName')" class="invalid-feedback">
            {{ errors.first("LastName") }}
          </div>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >First Name :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
          v-validate="'max:200'"
            type="text"
            name="FirstName"
            v-model="encodingData.FirstName"
            class="form-control"
            :class="{ 'is-invalid': submitted && errors.has('FirstName') }"
          />
          <div v-if="submitted && errors.has('FirstName')" class="invalid-feedback">
            {{ errors.first("FirstName") }}
          </div>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Middle Name :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
          v-validate="'max:200'"
            type="text"
            name="MiddleName"
            v-model="encodingData.MiddleName"
            class="form-control"
            :class="{ 'is-invalid': submitted && errors.has('MiddleName') }"
          />
          <div v-if="submitted && errors.has('MiddleName')" class="invalid-feedback">
            {{ errors.first("MiddleName") }}
          </div>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Country:</label
        >
        <div class="col-md-6 col-sm-6">
          <select
            name="BirthCountry"
            v-model="encodingData.BirthCountry"
            class="form-control"
          >
            <option value>Select Birth Country</option>
            <option
              v-for="option in countries"
              v-bind:value="option.countryName"
              v-bind:key="option.countryName"
            >
              {{ option.countryName }}
            </option>
          </select>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >BirthDate :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            type="date"
            name="BirthDate"
            v-model="encodingData.BirthDate"
            class="form-control"
          />
        </div>
      </div>

      <div class="ln_solid"></div>
      <div class="item form-group">
        <div class="col-md-6 col-sm-6">
          <button type="submit" class="btn btn-primary">Save</button>&nbsp;
          <button
            type="button"
            v-on:click="clearControls()"
            class="btn btn-primary"
          >
            Clear
          </button>
        </div>
      </div>
    </form>
    <b-modal id="LinkPopPP" title="Link Builder" scrollable hide-footer>
      <LinkPopUp />
    </b-modal>
  </div>
</template>

<script>
import {
  authHeader,
  responseCheck,
  notifyHelper,
  EncodeURL,
  checkLinkMode,
  getlocalstorageCountry,
  getlocalstorageProvince,
  getlocalstoragePaperType,
  setObject2Link,
} from "../../helper";
import LinkPopUp from "../master/Linking";
import instance from "../../helper/http";
export default {
  data() {
    return {
      encodingData: {
        Type: "",
        ReferenceNo: "",
        IssuingAgency: "",
        IssuanceDate: null,
        Country: "",
        State: "",
        City: "",
        Address: "",
        Comments: "",
        LastName: "",
        FirstName: "",
        MiddleName: "",
        BirthCountry: "",
        BirthDate: null,
      },
      countries: [],
      provinces: [],
      types: [],
    };
  },
  components: {
    LinkPopUp,
  },
  methods: {
    handleSubmit() {
      let loader = this.$loading.show();
      instance
        .post(EncodeURL + "newOfficialPapers", this.encodingData, {
          headers: authHeader(),
        })
        .then((response) => {
          if (response.data.error) {
            loader.hide();
            notifyHelper(
              "error",
              "There was an error processing your request!"
            );
          } else {
            loader.hide();
            notifyHelper("success", "Saved");
            //this.clearControls()
            if (checkLinkMode()) {
              if (confirm("Link this newly created entity?")) {
                setObject2Link(response.data.id, "PP");
                this.setLink(response.data.id);
              }
            }
          }
        })
        .catch((error) => {
          loader.hide();
          responseCheck(error.response.status);
        })
        .finally(() => loader.hide());
    },
    getlibs() {
      this.countries = getlocalstorageCountry();
      this.provinces = getlocalstorageProvince();
      this.types = getlocalstoragePaperType();
    },
    setLink: function (id) {
      setObject2Link(id, "PP");
      this.$bvModal.show("LinkPopPP");
    },
    clearControls() {
      this.encodingData.Type = "";
      this.encodingData.ReferenceNo = "";
      this.encodingData.IssuingAgency = "";
      this.encodingData.IssuanceDate = null;
      this.encodingData.Country = "";
      this.encodingData.State = "";
      this.encodingData.City = "";
      this.encodingData.Address = "";
      this.encodingData.Comments = "";
      this.encodingData.LastName = "";
      this.encodingData.FirstName = "";
      this.encodingData.MiddleName = "";
      this.encodingData.BirthCountry = "";
      this.encodingData.BirthDate = null;
    },
  },
  created: function () {
    this.getlibs();
  },
};
</script>

